export const NOTIFICATION_TYPES = {
  ROW_DELETE: 'ROW_DELETE',
  GRID_SHARE: 'GRID_SHARE',
  ME_TO_AV_NEW_COMPONENT: 'ME_TO_AV_NEW_COMPONENT',
  ME_STOPPED_INDUSTRIALIZATION: 'ME_STOPPED_INDUSTRIALIZATION',
  AV_TO_DOWNSTREAM_HANDOFF: 'AV_TO_DOWNSTREAM_HANDOFF',
  DOWNSTREAM_STATUS_UPDATE_TO_AV: 'DOWNSTREAM_STATUS_UPDATE_TO_AV',
} as const;

export type NotificationType = (typeof NOTIFICATION_TYPES)[keyof typeof NOTIFICATION_TYPES];
